import map from 'lodash/map';
import Skeleton from 'antd/lib/skeleton/Skeleton';

import SettingsFormItemSkeleton from 'components/Skeletons/Settings/SettingsFormItemSkeleton';
import { SettingsSkeletonStyled } from 'components/Skeletons/Settings/styled';

const SettingsSkeleton = () => (
  <SettingsSkeletonStyled>
    <Skeleton.Button active className="h-10 w-64 mb-5" />
    <div className="flex flex-wrap gap-x-5 gap-y-8">
      {map(Array(14), (_, key) => <SettingsFormItemSkeleton key={key} />)}
    </div>
  </SettingsSkeletonStyled>
);

export default SettingsSkeleton;
